import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Config } from 'datatables.net';
import { Subject } from 'rxjs';
import { ReportService } from 'src/app/services/report.service';
import { SocketService } from 'src/app/services/socket.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-payment-pds',
  templateUrl: './payment-pds.component.html',
  styleUrls: ['./payment-pds.component.css'],
})
export class PaymentPdsComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private router: Router,
    private service: ReportService,
    private socket: SocketService
  ) {}

  role: string;

  // configs
  dtOptions: Config = {
    pagingType: 'simple_numbers',
    language: {
      searchPlaceholder: 'Search here...',
    },
  };
  dtTrigger: Subject<any> = new Subject<any>();

  type: string = 'SCHEDULED';
  date: Date | Date[];
  maxDateForPicker: Date;

  isView = false;

  ngOnInit(): void {
    this.role = sessionStorage.getItem('role');

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    this.maxDateForPicker = new Date(currentYear, currentMonth + 2);

    this.date = new Date(currentYear, currentMonth + 1, 1)
  }

  applyFilters() {
    this.isView = true;
  }

  resetFilters() {}

  onTypeChange() {
    console.log(typeof this.date)
    if (typeof this.date == 'object') {
      
    }
    this.date = undefined;
  }
}
